import {msgIdPrefix} from './constants';

export const uniqueId = () => {
    return Date.now().toString(36) + Math.random().toString(36).substring(2, 5);
};

export const genMsgId = () => {
    return msgIdPrefix + uniqueId();
};
